<template>
  <div>
    <div v-for="(item, index) in data" :key="index" class="references__item">
      <span class="references__index">{{ index + 1 }}</span>
      <span class="references__content" v-html="item" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'References',

  props: {
    data: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.references {
  width: 100%;
  height: 100%;
  padding: 0 rem(45) 0 0;

  &__item {
    @include flexbox(flex-start, flex-start);

    &:not(:last-child) {
      margin-bottom: 1rem;
    }
  }

  &__content,
  &__index {
    color: #646464;
    font-size: rem(16);
    width: 90%;
  }

  &__index {
    width: rem(60);
    font-weight: $font-bold;
  }

  @include iPadProStyles {
    &__content,
    &__index {
      font-size: rem(20);
    }
  }
}
</style>
